import { render, staticRenderFns } from "./PremiumMonthlyPromoSection.vue?vue&type=template&id=f50a0728&"
import script from "./PremiumMonthlyPromoSection.vue?vue&type=script&lang=js&"
export * from "./PremiumMonthlyPromoSection.vue?vue&type=script&lang=js&"
import style0 from "./PremiumMonthlyPromoSection.vue?vue&type=style&index=0&id=f50a0728&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports